import useSWR from 'swr';
import { useAuthToken } from '@/contexts/auth/useAuthToken';
import { FixtureCollectionCheck } from '../types';
import {
  fetchFromMTService,
  SERVICE_ENDPOINT,
} from '../fetcher/monitoringToolService';
import { ApiError } from '../ApiError';
import { HTTP_STATUS_CODE } from '../constants';
import { UseFixtureConfigParams } from './useFixtureConfig';

export const useFixtureCollectionCheck = ({
  fixtureId,
  collectionId,
}: UseFixtureConfigParams) => {
  const token = useAuthToken();

  const { data, error } = useSWR<FixtureCollectionCheck, ApiError>(
    token && (fixtureId || collectionId)
      ? {
          token,
          endpoint: SERVICE_ENDPOINT.Configurations(fixtureId || collectionId)
            .FixtureCheck.GET,
        }
      : null,
    fetchFromMTService,
    {
      onErrorRetry: (e, _, config, revalidate, { retryCount }) => {
        if (e.status === HTTP_STATUS_CODE.NOT_FOUND) return;
        if (e.status === HTTP_STATUS_CODE.UNAUTHORIZED) return;
        setTimeout(() => revalidate({ retryCount }), config.errorRetryInterval);
      },
      revalidateOnFocus: false,
    },
  );

  return {
    fixtureId: data?.fixtureId,
    collectionId: data?.collectionId,
    error,
    isLoading: !data && !error,
  };
};
